import { render, staticRenderFns } from "./cars-nav-mobile.vue?vue&type=template&id=5b6a2d64&scoped=true&"
import script from "./cars-nav-mobile.vue?vue&type=script&lang=js&"
export * from "./cars-nav-mobile.vue?vue&type=script&lang=js&"
import style0 from "./cars-nav-mobile.vue?vue&type=style&index=0&id=5b6a2d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a2d64",
  null
  
)

export default component.exports